import AbstractApiRepository from '~/base/api/AbstractApiRepository';

import { LangTypeEnum } from '../types/Lang';

export default class LangApiRepository extends AbstractApiRepository {
  setLanguage = (language: LangTypeEnum) => {
    this.apiClient.setLanguage(language);
  };
}
